var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Remboursement des dépenses")]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-wrap" }, [
      _c(
        "table",
        {
          staticClass: "table table-bordered table-compact mr-2",
          staticStyle: { width: "auto" }
        },
        [
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "text-right" }, [
                _vm._v(
                  _vm._s(_vm.kmTotal) + " km x " + _vm._s(_vm.kmRate) + " $/km:"
                )
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatMoney(_vm.kmTotal * _vm.kmRate)))
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "text-right" }, [_vm._v("Dépenses:")]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatMoney(_vm.expensesAmountWithoutTax)))
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table table-bordered table-compact",
          staticStyle: { width: "auto" }
        },
        [
          _c("tbody", [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatMoney(_vm.subTotal)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatMoney(_vm.totalTaxes.tps)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatMoney(_vm.totalTaxes.tvq)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(
                  _vm._s(
                    _vm.formatMoney(
                      _vm.subTotal + _vm.totalTaxes.tps + _vm.totalTaxes.tvq
                    )
                  )
                )
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "text-center" }, [_vm._v("S-Total")]),
      _vm._v(" "),
      _c("td", { staticClass: "text-center" }, [_vm._v("TPS")]),
      _vm._v(" "),
      _c("td", { staticClass: "text-center" }, [_vm._v("TVQ")]),
      _vm._v(" "),
      _c("td", { staticClass: "text-center bold" }, [_vm._v("Total")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }